import React from "react";

export default function NotificationBell({ count, hasSignal, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative inline-flex h-11 w-11 items-center justify-center rounded-2xl border bg-white text-gray-700 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:bg-[#111827] dark:text-gray-100 ${
        hasSignal
          ? "border-red-400 ring-4 ring-red-200 dark:border-red-600 dark:ring-red-900/40"
          : "border-gray-200 dark:border-white/10"
      }`}
      title="알림"
    >
      <svg
        viewBox="0 0 24 24"
        className={`h-5 w-5 ${hasSignal ? "animate-pulse" : ""}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
        <path d="M13.73 21a2 2 0 01-3.46 0" />
      </svg>

      {hasSignal && (
        <>
          <span className="absolute right-1.5 top-1.5 inline-flex h-3 w-3 animate-ping rounded-full bg-red-400 opacity-75" />
          <span className="absolute right-1.5 top-1.5 inline-flex h-3 w-3 rounded-full bg-red-500" />
        </>
      )}

      {count > 0 && (
        <span className="absolute -right-1 -top-1 min-w-[20px] rounded-full bg-red-500 px-1.5 py-0.5 text-[11px] font-bold leading-none text-white">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}